import { memo, useMemo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EntityAvatarGroup } from "@components/avatar/EntityAvatarGroup";
import { useEntities } from "@hooks/useEntities";
import { NestedEditorRow } from "../nestedRowTypes";

// Mirrors the chart page's own EntitiesCell.
export const NestedEntitiesCell = memo(
    ({ row }: CellContext<ViewTableFeatures, NestedEditorRow, unknown>) => {
        const { accounts, groups } = row.original;
        const entities = useEntities({ onlyBusiness: true });

        const rowEntityIds = useMemo(
            () =>
                new Set([
                    ...accounts.map((account) => account.entityId),
                    ...groups.map((group) => group.entityId),
                ]),
            [accounts, groups],
        );

        if (rowEntityIds.size === 0) {
            return <ViewTableCell />;
        }

        return (
            <ViewTableCell>
                <EntityAvatarGroup
                    entities={entities.filter((entity) =>
                        rowEntityIds.has(entity.id),
                    )}
                    max={3}
                    size="xs"
                />
            </ViewTableCell>
        );
    },
);

NestedEntitiesCell.displayName = "NestedEntitiesCell";
